import { defineMessages } from 'react-intl'

export default defineMessages({
    euVatIdNotValid: {
        id: 'containers.CustomerPage.RequiredFields.euVatIdNotValid',
        defaultMessage: 'VAT number is not valid. Please remember to check it later!',
    },
    validatingEuVatId: {
        id: 'containers.CustomerPage.RequiredFields.validatingEuVatId',
        defaultMessage: 'Validating VAT number',
    },
    confirmEmptyVatId: {
        id: 'containers.CustomerPage.RequiredFields.confirmEmptyVatId',
        defaultMessage: 'Are you sure that VAT ID should be empty?',
    }
})
